// extracted by css-extract-rspack-plugin
export default {"phoneContainer":"phone-container--yVUeX0FjS49v8ZgI"};